import React from "react";
import { EventTypesProvider } from "./EventTypesProvider";

const NotificationsProvider: React.FC = ({ children }) => (
  <EventTypesProvider>{children}</EventTypesProvider>
);

export { NotificationsProvider };
